export enum ActionType {
  // CONTRACTS
  LOAD_CONTRACTS_FOR_DASHBOARD_SUCCESS = '[CONTRACTS] LOAD_CONTRACTS_FOR_DASHBOARD_SUCCESS',
  LOAD_ALL_CUSTOMER_CONTRACTS_SUCCESS = '[CONTRACTS] LOAD_ALL_CUSTOMER_CONTRACTS_SUCCESS',
  LOAD_CUSTOMER_STATS_SUCCESS = '[CONTRACTS] LOAD_CUSTOMER_STATS_SUCCESS',
  LOAD_CUSTOMER_STATS_BY_PRODUCT_SUCCESS = '[CONTRACTS] LOAD_CUSTOMER_STATS_BY_PRODUCT_SUCCESS',
  LOAD_CUSTOMER_STATS_BY_NATURE_SUCCESS = '[CONTRACTS] LOAD_CUSTOMER_STATS_BY_NATURE_SUCCESS',
  LOAD_CUSTOMER_STATS_BY_VEHICLE_FUEL_TYPE_SUCCESS = '[CONTRACTS] LOAD_CUSTOMER_STATS_BY_VEHICLE_FUEL_TYPE_SUCCESS',
  LOAD_CUSTOMER_STATS_BY_VEHICLE_MAKE_SUCCESS = '[CONTRACTS] LOAD_CUSTOMER_STATS_BY_VEHICLE_MAKE_SUCCESS',

  // CUSTOMERS
  LOAD_CUSTOMERS_IN_PROGRESS = '[CUSTOMERS] LOAD_CUSTOMERS_IN_PROGRESS',
  LOAD_CUSTOMERS_SUCCESS = '[CUSTOMERS] LOAD_CUSTOMERS_SUCCESS',

  // REPORTS
  LOAD_AVAILABLE_REPORTS_SUCCESS = '[REPORTS] LOAD_AVAILABLE_REPORTS_SUCCESS',
  LOAD_REPORT_CLEAR = '[REPORTS] LOAD_REPORT_CLEAR',
  LOAD_REPORT_SUCCESS = '[REPORTS] LOAD_REPORT_SUCCESS',

  // ORDERS
  LOAD_ORDER_FORMS_IN_PROGRESS = '[ORDERS] LOAD_ORDER_FORMS_IN_PROGRESS',
  LOAD_ORDER_FORMS_SUCESS = '[ORDERS] LOAD_ORDER_FORMS_SUCESS',
  LOAD_ORDERS_SUCESS = '[ORDERS] LOAD_ORDERS_SUCESS',
  SUBMIT_ORDER_SUCESS = '[ORDERS] SUBMIT_ORDER_SUCESS',
  SUBMIT_APPROVAL_SUCESS = '[ORDERS] SUBMIT_APPROVAL_SUCESS',
  LOAD_TENANT_FUEL_CARD_SETS_SUCESS = '[ORDERS] LOAD_TENANT_FUEL_CARD_SETS_SUCESS',
  DELETE_TENANT_FUEL_CARD_SET_SUCESS = '[ORDERS] DELETE_TENANT_FUEL_CARD_SET_SUCESS',
  LOAD_FUEL_CARDS_SUCESS = '[ORDERS] LOAD_FUEL_CARDS_SUCESS',
  DELETE_FUEL_CARD_SUCESS = '[ORDERS] DELETE_FUEL_CARD_SUCESS',

  // WORKFLOWCONFIGS
  LOAD_WORKFLOW_CONFIGS_SUCESS = '[WORKFLOWCONFIGS] LOAD_WORKFLOW_CONFIGS_SUCESS',

  // SUPPLIER WORKFLOW CONFIGS
  LOAD_SUPPLIER_WORKFLOW_CONFIGS_SUCESS = '[SUPPLIERWORKFLOWCONFIGS] LOAD_SUPPLIER_WORKFLOW_CONFIGS_SUCESS',

  // USER
  SET_USER = 'SET_USER',
  SET_USER_PROPS = 'SET_USER_PROPS',

  // MANAGER
  SET_MANAGER = 'SET_MANAGER',

  // APP
  GET_APP_VERSION_SUCCESS = '[APP] GET_APP_VERSION_SUCCESS',
}
